import { CityContact, CityContactProps } from "./CityContact.model";

export interface CityProps {
  name: string;

  cityContact: CityContactProps;
}

export class City {
  constructor(
    readonly name: string,

    public contact: CityContact
  ) {}

  static create(props: CityProps) {
    return new City(
      props.name,
      !props.cityContact
        ? CityContact.createEmpty()
        : CityContact.create(props.cityContact)
    );
  }

  static createMany(props: CityProps[]) {
    return props.map((x) => City.create(x));
  }
}
